import { ERC20V2 } from "logic/pages/LoansPage/data/types";

import { useWithdrawBridgeTx } from "./useWithdrawBridgeTx";
import { useWithdrawLocalTx } from "./useWithdrawLocalTx";

interface useWithdrawTxParams {
  token: ERC20V2;
  chainId: number;
  destinationChainId: number;
  amount: bigint;
  recipient: string;
  mainActionLabel?: string;
  enabled?: boolean;
}

export function useWithdrawTx(params: useWithdrawTxParams) {
  const { destinationChainId, ...rest } = params;
  const isLocalTransfer = params.chainId === destinationChainId;

  const localTx = useWithdrawLocalTx({
    ...rest,
    enabled: (rest.enabled ?? true) && isLocalTransfer,
  });

  const bridgeTx = useWithdrawBridgeTx({
    ...rest,
    enabled: (rest.enabled ?? true) && !isLocalTransfer,
  });

  return isLocalTransfer ? localTx : bridgeTx;
}
